module.exports = __webpack_public_path__ + "media/images/common/ui/btn_chariloto_5-65e97af3fceed2d2d20246d583d4471a.png";